import { Flows } from '@flows';

export interface AppSettingsType {
	entryPointFlow: Flows;
	stickyBarStatus: boolean;
}

export type ViewSizeType = 'smallView' | 'bigView' | 'tabletView';

export enum BaseSessionInfoCompany {
	AB = 'AB', // Activo Bank
	BCP = 'BCP', // Millennium BCP
}

export enum BaseSessionInfoLanguage {
	EN = 'EN',
	PT = 'PT',
}

export enum BaseSessionInfoFlow {
	clPublicSimulator = 'clPublicSimulator',
}

/* cSpell: disable */
export enum BaseSessionInfoLoanType {
	AL = 'AL', // Auto Loans
	CL = 'CL', // Credit Loans
	ER = 'ER', // Energy Loans
	PA = 'PA', // Pre approval
	TU = 'TU', // Top Ups
	ML = 'ML', // MORTGAGE LOAN
	CLECO = 'CLECO', // Credit Loans Eco Ab
	CLENE = 'CLENE', // Credit Loans +Energy Ab
	RENEN = 'RENEN', // Renewable Energies Flow
	ALEV = 'ALEV', // Auto Electric Loans
	AN = 'AN',
	EDUCA = 'EDUCA',
	HEALTH = 'HEALTH',
	HOME = 'HOME',
	CONSTR = 'CONSTR',
}
/* cSpell: enable */

export interface SessionInfoApi {
	subscriptionKey: string;
	tokenOAuth: string;
}

export interface SessionInfoJourneyData {
	flow: BaseSessionInfoFlow;
	loanType: BaseSessionInfoLoanType;
	amount?: number;
	term?: number;
	chips?: boolean;
}

export interface BaseSessionInfo {
	api: SessionInfoApi;
	language: BaseSessionInfoLanguage;
	company: BaseSessionInfoCompany;
	application: string;
	targetSystem: string;
	geo: string;
	journeyData: SessionInfoJourneyData;
	shadow?: HTMLElement;
	// when logged
	// alias: string;
	// sessionId: string;
	// targetInfrastructure: string;
}
